import store from "@/store";

export default {
  getAgencies() {
    return store.state.api.get('/services/agencies/list');
  },
  getGenericURI(URI) {
    return store.state.api.get(URI);
  }
}